import React, { useEffect, useState } from 'react';
import Base from '../Base';
import Title from '../../components/common/Title';
import { useTranslation } from 'react-i18next';
import { apiRequest } from '../../utils';
import './MyPrizes.css';

/* What this person won in a raffle — private: /api/my-prizes only ever returns their own wins.

   A prize that is still `drawn` is the urgent one: they have to walk to the raffle stand now, or
   the operator draws it again for somebody else. A forfeited prize stays listed ("went to someone
   else") so a no-show sees what happened instead of a prize that vanished. */

const money = (value, currency) => {
  if (value === null || value === undefined) return null;
  const n = Number(value);
  return `${currency ? `${currency} ` : ''}${Number.isInteger(n) ? n.toLocaleString() : n.toFixed(2)}`;
};

const Page = () => {
  const { t } = useTranslation('common');
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    const load = () => apiRequest('GET', '/my-prizes')
      .then((res) => { if (active) setData(res); })
      .catch(() => { if (active) setFailed(true); });
    load();
    // While a draw is under way, a "collect now" can turn into "collected" or "went to someone
    // else" in front of them — keep the page honest without a reload.
    const id = setInterval(() => { if (document.visibilityState === 'visible') load(); }, 20000);
    return () => { active = false; clearInterval(id); };
  }, []);

  const prizes = data?.prizes || [];

  return (
    <Base activeNav="user">
      <Title>{t('myPrizes')}</Title>
      <div className="mp-page">
        {failed && <p className="text-muted">{t('somethingWentWrong')}</p>}
        {data && prizes.length === 0 && <p className="text-muted">{t('myPrizesEmpty')}</p>}
        {prizes.map((p) => (
          <div key={p.id} className={`mp-card mp-card--${p.status}`}>
            {p.prize_photo_url
              ? <span className="mp-card__img" style={{ backgroundImage: `url("${p.prize_photo_url}")` }} />
              : <span className="mp-card__img mp-card__img--none"><i className="fi fi-br-gift" /></span>}
            <div className="mp-card__body">
              <div className="mp-card__name">{p.prize_name}</div>
              {p.sponsor && <div className="mp-card__meta">{t('raffleScreenBy', { sponsor: p.sponsor })}</div>}
              {money(p.prize_value, p.currency) && <div className="mp-card__meta">{money(p.prize_value, p.currency)}</div>}
              {p.event_name && <div className="mp-card__meta">{p.event_name}</div>}
              <div className={`mp-card__status mp-card__status--${p.status}`}>
                {p.status === 'drawn' && t('prizeCollectNow')}
                {p.status === 'collected' && t('prizeCollected')}
                {p.status === 'forfeited' && t('prizeForfeited')}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Base>
  );
};

export default Page;
